module.exports = __webpack_public_path__ + "static/img/suwen_platform_logo.2c95b4f4.png";